import domReady from '@wordpress/dom-ready';
import { applyFilters } from '@wordpress/hooks';

domReady(() => {
    // Opens Booking Modal
    const openBookingModal = () => {

        let appContainer = document.querySelector('#wptravelengine-trip-booking-modal') ?? null
        if (!appContainer) {
            appContainer = document.createElement('div')
            appContainer.style.display = 'none'
            appContainer.style.height = 0
            appContainer.id = 'wptravelengine-trip-booking-modal'
            document.body.appendChild(appContainer)
        }

        document.querySelectorAll('.wte-fsd__booknow-btn').forEach(btn => {
            btn.disabled = false;
            btn.classList.remove('btn-loading');

            if (!applyFilters('wptravelengine.tripBookingModal.open', true, { appContainer })) {
                return
            }

            // find the parent element which has the data-trip-id attribute
            let parent = btn.parentElement;
            while (parent && !parent.dataset.tripId) {
                parent = parent.parentElement;
            }

            btn.addEventListener('click', () => {
                const packageId = btn.dataset.packageId;
                const { state, setState } = window?.wptravelengineBooking?.store;
                setTimeout(() => setState({ isOpen: true, isFsd: fsd_settings.skip_date_selection }));
                setState({
                    summary: {
                        ...state.summary,
                        selectedTripDate: btn.dataset?.date || null,
                        selectedTripPackageID: parseInt(packageId || 0),
                    },
                    tripID: Number(parent.dataset.tripId) ?? null,
                    currentTab: 0,
                    isLoading: true
                });
            });
        });
    };

    openBookingModal();

    // Get fixed departure dates list
    const getDateList = (date, tripId, nonce, isShortcode = false, count, isShowMore = false) => async (el) => {
        const url = wte_fix_date.ajaxurl;
        let parent = el.parentElement
        while (parent && !parent.classList.contains('wte-fsd__container')) {
            parent = parent.parentElement;
        }
        const listWrapper = parent.querySelector('.wte-fsd__availability-list-wrap');
        el.classList.add('btn-loading');
        el.disabled = true;
        parent.classList.add('loading');
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: isShowMore ? 'load_more_dates' : 'filter_departure_dates',
                    date,
                    tripID: tripId,
                    _nonce: nonce,
                    is_singular_trip: tripId,
                    is_shortcode: isShortcode,
                    count: count || parent.dataset.datesLimit,
                    btn_attributes: parent?.dataset?.setAttributes
                }),
            });

            const jsonResponse = await response.json();

            if (jsonResponse.success && jsonResponse.data?.html) {
                listWrapper.innerHTML = jsonResponse.data.html;
                openBookingModal();
                parent.classList.remove('loading');
                el.classList.remove('btn-loading');
                el.disabled = false;
                if (el.matches('.wte-fsd__availability-show-less')) {
                    var screenh = window.innerHeight;
                    var toScroll = '' + screenh / 10;
                    parent.scrollIntoView(false);
                    window.scrollBy(0, toScroll);
                }
            } else {
                console.error('Invalid HTML returned:', jsonResponse);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    // Handle tab change
    const handleSelectTab = (parent, tab) => {
        const groupContents = parent.querySelectorAll('[data-tab-of="group"]');
        const privateContents = parent.querySelectorAll('[data-tab-of="private"]');
        groupContents.forEach(content => content.style.display = tab === 'group' ? null : 'none');
        privateContents.forEach(content => content.style.display = tab === 'group' ? 'none' : 'block');
    };

    // Handle click on select date
    const fsdButtons = document.querySelectorAll('.wte-fsd__button');
    fsdButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            let parent = e.target.parentElement
            while (parent && !parent.classList.contains('wte-fsd__container')) {
                parent = parent.parentElement;
            }
            const { date, tab } = e.target.dataset;
            const { tripId, nonce, isShortcode } = e.target.parentElement.dataset;
            e.target.parentElement.querySelector('.is-active')?.classList.remove('is-active');
            e.target.classList.add('is-active');
            if (date) getDateList(date, tripId, nonce, isShortcode)(e.target);
            if (tab) handleSelectTab(parent, tab);
        });
    });

    // On change fsd select input
    const fsdSelects = document.querySelectorAll('.wte-fsd__date-select');
    if (fsdSelects) {
        fsdSelects.forEach(fsdSelect => {
            fsdSelect.addEventListener('change', (e) => {
                const { tripId, nonce, isShortcode } = e.target.dataset;
                getDateList(e.target.value, tripId, nonce, isShortcode)(fsdSelect);
            });
        });
    }

    // Handle click on show more button
    document.addEventListener('click', (e) => {
        const showMoreBtn = e.target.closest('.wte-fsd__availability-show-more');
        const showLessBtn = e.target.closest('.wte-fsd__availability-show-less');
        if (showMoreBtn || showLessBtn) {
            let parent = e.target.parentElement
            while (parent && !parent.classList.contains('wte-fsd__container')) {
                parent = parent.parentElement;
            }
            const tripData = parent.querySelector('.wte-fsd__filter-buttons');
            const activeFilterBtn = tripData.querySelector('.is-active') ?? tripData;
            const datesLimit = parseInt(parent.dataset.datesLimit);
            const itemsCount = parseInt(parent.querySelector('.wte-fsd__availability-list').dataset.itemsCount);
            const count = showLessBtn ? itemsCount - datesLimit : itemsCount + datesLimit;
            const date = activeFilterBtn?.dataset.date || '';
            if (tripData) {
                getDateList(date, tripData.dataset.tripId, tripData.dataset.nonce, tripData.dataset.isShortcode, count, true)(e.target);
            } else {
                console.error('No trip data found');
            }
        }
    });

    // status dropdown
    const statusDropdownInit = () => {
        tippy("[data-tippy-content]", {
            theme: 'light',
        })
    }
    statusDropdownInit();
    const fsdContainers = document?.querySelector(".wte-fsd__container") ?? null;
    if (fsdContainers) {
        const observer = new MutationObserver(() => {
            statusDropdownInit();
        })
        observer.observe(fsdContainers, { childList: true, subtree: true });
    }
})